import React, { useState, useEffect, useCallback } from 'react';

// ============================================================================
// YAYINEVLERİ (2026-09-15, kullanıcı kararı) — Satış Arşivi'nin 4. sekmesi.
// Yayınevleri DB listesidir (GET /api/yayinevi — pasifler dahil); burada
// eklenir (+ Yeni yayınevi: ad + notlar), yeniden adlandırılır (PATCH {ad}),
// notu düzenlenir (PATCH {notlar}) ve pasife alınır / aktif edilir (PATCH
// {aktif}). Silme YOK — satış kayıtları yayınevine bağlıdır; pasif yayınevi
// seçicilerde görünmez ama arşivde adı durur.
//
// Yanıt sözleşmesi: { basarili, yayinevleri:[{id, ad, aktif, notlar,
//   satis_sayisi, teslim_sayisi}] }; PATCH → { basarili, yayinevi } (satıra
//   BİRLEŞTİRİLİR); 409 yayinevi_ad_cakisma → { hata, mevcut:{id, ad} }.
// Hata satır düzeyinde (`data-yayinevi-hata`), satır değişmez.
// ============================================================================
const girdi = 'px-2 py-1 border border-gray-300 rounded text-xs bg-white';

function Satir({ y, apiUrl, authFetch, onGuncelle }) {
  const [kip, setKip] = useState(null);       // 'ad' | 'not' | null
  const [deger, setDeger] = useState('');
  const [mesgul, setMesgul] = useState(false);
  const [hata, setHata] = useState('');

  const patch = async (govde) => {
    setMesgul(true); setHata('');
    try {
      const r = await authFetch(`${apiUrl}/api/yayinevi/${y.id}`, { method: 'PATCH', body: JSON.stringify(govde) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d || !d.basarili || !d.yayinevi) {
        const cakisma = d && d.red_nedeni === 'yayinevi_ad_cakisma' && d.mevcut
          ? ` (kayıtlı: “${d.mevcut.ad}”, #${d.mevcut.id})` : '';
        throw new Error(((d && d.hata) || `Güncellenemedi${r.status ? ` (HTTP ${r.status})` : ''}`) + cakisma);
      }
      onGuncelle({ ...y, ...d.yayinevi });
      setKip(null); setDeger('');
    } catch (e) {
      setHata(e.message || 'Güncellenemedi');
    }
    setMesgul(false);
  };

  const ac = (k) => { setKip(k); setHata(''); setDeger(k === 'ad' ? (y.ad || '') : (y.notlar || '')); };
  const kaydet = () => {
    if (kip === 'ad') {
      const ad = deger.trim();
      if (!ad) { setHata('Yayınevi adı boş olamaz'); return; }
      patch({ ad });
    } else if (kip === 'not') {
      patch({ notlar: deger.trim() });
    }
  };
  const tusla = (e) => {
    if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); kaydet(); }
    else if (e.key === 'Escape') { e.preventDefault(); setKip(null); setHata(''); }
  };
  const aktif = y.aktif !== false;

  return (
    <tr data-yayinevi-satir={y.id} className={`border-t border-gray-100 ${aktif ? '' : 'bg-gray-50 text-gray-500'}`}>
      <td className="px-3 py-2 font-medium text-gray-800">
        {kip === 'ad' ? (
          <span className="inline-flex items-center gap-1.5">
            <input data-yayinevi-ad-girdi value={deger} onChange={(e) => setDeger(e.target.value)} onKeyDown={tusla}
              maxLength={120} autoFocus className={`${girdi} w-44`} />
            <button type="button" onClick={kaydet} disabled={mesgul}
              className="px-2 py-1 rounded bg-emerald-600 text-white text-xs font-semibold hover:bg-emerald-700 disabled:opacity-40">Kaydet</button>
            <button type="button" onClick={() => { setKip(null); setHata(''); }} disabled={mesgul}
              className="px-2 py-1 rounded border border-gray-300 text-xs hover:bg-gray-50 disabled:opacity-40">Vazgeç</button>
          </span>
        ) : (
          <span data-yayinevi-ad>{y.ad}</span>
        )}
      </td>
      <td className="px-3 py-2">
        <span data-yayinevi-durum={aktif ? 'aktif' : 'pasif'}
          className={`inline-block px-1.5 py-0.5 rounded border text-[11px] font-semibold ${aktif
            ? 'bg-emerald-100 text-emerald-800 border-emerald-300' : 'bg-gray-200 text-gray-700 border-gray-300'}`}>
          {aktif ? 'Aktif' : 'Pasif'}
        </span>
      </td>
      <td className="px-3 py-2 text-gray-600 whitespace-nowrap" title="Aktif satış · fiyat bekleyen teslim">
        {Number(y.satis_sayisi) || 0} satış{Number(y.teslim_sayisi) > 0 ? ` · ${Number(y.teslim_sayisi)} teslim` : ''}
      </td>
      <td className="px-3 py-2 text-gray-600 max-w-[260px]">
        {kip === 'not' ? (
          <span className="inline-flex items-center gap-1.5 w-full">
            <input data-yayinevi-not-girdi value={deger} onChange={(e) => setDeger(e.target.value)} onKeyDown={tusla}
              maxLength={500} autoFocus placeholder="Not" className={`${girdi} flex-1`} />
            <button type="button" onClick={kaydet} disabled={mesgul}
              className="px-2 py-1 rounded bg-emerald-600 text-white text-xs font-semibold hover:bg-emerald-700 disabled:opacity-40">Kaydet</button>
            <button type="button" onClick={() => { setKip(null); setHata(''); }} disabled={mesgul}
              className="px-2 py-1 rounded border border-gray-300 text-xs hover:bg-gray-50 disabled:opacity-40">Vazgeç</button>
          </span>
        ) : (
          <span data-yayinevi-not className="block truncate" title={y.notlar || ''}>{y.notlar || '—'}</span>
        )}
      </td>
      <td className="px-3 py-2 whitespace-nowrap">
        <div className="flex flex-wrap items-center gap-1.5">
          <button type="button" onClick={() => ac('ad')} disabled={mesgul || kip === 'ad'} title="Adı değiştir"
            className="px-2 py-1 rounded border border-gray-300 text-xs hover:bg-gray-50 disabled:opacity-40">✏ Ad</button>
          <button type="button" onClick={() => ac('not')} disabled={mesgul || kip === 'not'} title="Notu düzenle"
            className="px-2 py-1 rounded border border-gray-300 text-xs hover:bg-gray-50 disabled:opacity-40">📝 Not</button>
          <button type="button" onClick={() => patch({ aktif: !aktif })} disabled={mesgul}
            title={aktif ? 'Pasife al: seçicilerde görünmez, arşiv kayıtları durur' : 'Yeniden aktif et'}
            className={`px-2 py-1 rounded border text-xs font-semibold disabled:opacity-40 ${aktif
              ? 'border-amber-300 text-amber-800 bg-amber-50 hover:bg-amber-100'
              : 'border-emerald-300 text-emerald-800 bg-emerald-50 hover:bg-emerald-100'}`}>
            {aktif ? 'Pasife al' : 'Aktif et'}
          </button>
        </div>
        {hata && <div data-yayinevi-hata className="mt-1 text-[11px] text-red-600 font-semibold">{hata}</div>}
      </td>
    </tr>
  );
}

export default function YayineviListesi({ apiUrl, authFetch }) {
  const [liste, setListe] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');
  const [yeniAcik, setYeniAcik] = useState(false);
  const [yeniAd, setYeniAd] = useState('');
  const [yeniNot, setYeniNot] = useState('');
  const [ekleniyor, setEkleniyor] = useState(false);
  const [ekleHata, setEkleHata] = useState('');
  const [bilgi, setBilgi] = useState('');

  const yukle = useCallback(async () => {
    setYukleniyor(true); setHata('');
    try {
      const r = await authFetch(`${apiUrl}/api/yayinevi`);
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d || !d.basarili || !Array.isArray(d.yayinevleri)) throw new Error((d && d.hata) || 'Yayınevi listesi alınamadı');
      setListe(d.yayinevleri);
    } catch (e) {
      setListe([]);
      setHata(e.message || 'Yayınevi listesi alınamadı');
    }
    setYukleniyor(false);
  }, [apiUrl, authFetch]);

  useEffect(() => { yukle(); }, [yukle]);

  const guncelle = (y) => setListe((p) => p.map((x) => (Number(x.id) === Number(y.id) ? y : x)));

  const ekle = async (e) => {
    if (e) e.preventDefault();
    const ad = yeniAd.trim();
    if (!ad) { setEkleHata('Yayınevi adı boş olamaz'); return; }
    setEkleniyor(true); setEkleHata(''); setBilgi('');
    try {
      const govde = { ad };
      if (yeniNot.trim()) govde.notlar = yeniNot.trim();
      const r = await authFetch(`${apiUrl}/api/yayinevi`, { method: 'POST', body: JSON.stringify(govde) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d || !d.basarili || !d.yayinevi) throw new Error((d && d.hata) || 'Yayınevi eklenemedi');
      const y = { satis_sayisi: 0, teslim_sayisi: 0, notlar: govde.notlar || null, ...d.yayinevi };
      setListe((p) => (p.some((x) => Number(x.id) === Number(y.id))
        ? p.map((x) => (Number(x.id) === Number(y.id) ? { ...x, ...y } : x))
        : [...p, y]));
      setBilgi(d.mevcut ? `“${y.ad}” zaten kayıtlıydı${y.aktif === false ? '' : ' — listede'}.` : `“${y.ad}” eklendi.`);
      setYeniAcik(false); setYeniAd(''); setYeniNot('');
    } catch (err) {
      setEkleHata(err.message || 'Yayınevi eklenemedi');
    }
    setEkleniyor(false);
  };

  return (
    <div data-yayinevi-listesi className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
      <div className="px-4 py-2.5 text-sm font-semibold text-gray-700 border-b border-gray-100 flex flex-wrap justify-between items-center gap-2">
        <span>Yayınevleri ({liste.length})</span>
        <div className="flex items-center gap-2 flex-wrap">
          {!yeniAcik && (
            <button type="button" onClick={() => { setYeniAcik(true); setEkleHata(''); setBilgi(''); }}
              className="px-2.5 py-1 rounded bg-emerald-600 text-white text-xs font-semibold hover:bg-emerald-700">
              + Yeni yayınevi
            </button>
          )}
          <button type="button" onClick={yukle} className="text-xs text-blue-600 hover:underline">Yenile</button>
        </div>
      </div>
      {yeniAcik && (
        <form onSubmit={ekle} data-yayinevi-yeni-form
          className="px-4 py-2.5 bg-emerald-50 border-b border-emerald-200 flex flex-wrap items-end gap-2">
          <div>
            <label className="block text-[10px] font-semibold text-gray-600 mb-0.5">Yayınevi adı</label>
            <input data-yayinevi-yeni-ad value={yeniAd} onChange={(e) => { setYeniAd(e.target.value); setEkleHata(''); }}
              maxLength={120} autoFocus placeholder="Örn. Karekök Yayınları" className={`${girdi} w-52`} />
          </div>
          <div className="flex-1 min-w-[200px]">
            <label className="block text-[10px] font-semibold text-gray-600 mb-0.5">Notlar (isteğe bağlı)</label>
            <input data-yayinevi-yeni-not value={yeniNot} onChange={(e) => setYeniNot(e.target.value)}
              maxLength={500} placeholder="İletişim, sözleşme notu…" className={`${girdi} w-full`} />
          </div>
          <button type="submit" disabled={ekleniyor}
            className="px-3 py-1.5 rounded bg-emerald-600 text-white text-xs font-semibold hover:bg-emerald-700 disabled:opacity-40">
            {ekleniyor ? 'Ekleniyor…' : 'Ekle'}
          </button>
          <button type="button" onClick={() => { setYeniAcik(false); setYeniAd(''); setYeniNot(''); setEkleHata(''); }} disabled={ekleniyor}
            className="px-3 py-1.5 rounded border border-gray-300 text-xs hover:bg-gray-50 disabled:opacity-40">Vazgeç</button>
          {ekleHata && <div data-yayinevi-ekle-hata className="w-full text-[11px] text-red-600 font-semibold">{ekleHata}</div>}
        </form>
      )}
      {bilgi && <div data-yayinevi-bilgi className="px-4 py-2 bg-green-50 border-b border-green-200 text-[12px] text-green-700">{bilgi}</div>}
      {hata && (
        <div data-yayinevi-liste-hata className="px-4 py-2 bg-red-50 border-b border-red-200 text-[12px] text-red-700 font-semibold">
          {hata} <button type="button" onClick={yukle} className="underline ml-1">Yeniden dene</button>
        </div>
      )}
      {yukleniyor ? (
        <div className="p-6 text-center text-gray-400 text-sm">Yükleniyor…</div>
      ) : liste.length === 0 ? (
        <div className="p-6 text-center text-gray-400 text-sm">Kayıtlı yayınevi yok — “+ Yeni yayınevi” ile ekleyin.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-500 text-xs">
              <tr>
                <th className="text-left px-3 py-2 font-semibold">Ad</th>
                <th className="text-left px-3 py-2 font-semibold">Durum</th>
                <th className="text-left px-3 py-2 font-semibold">Satış</th>
                <th className="text-left px-3 py-2 font-semibold">Notlar</th>
                <th className="text-left px-3 py-2 font-semibold">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {liste.map((y) => (
                <Satir key={y.id} y={y} apiUrl={apiUrl} authFetch={authFetch} onGuncelle={guncelle} />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
